 <template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in icon="Q" :title="title"></SectionTitle>
    <div class="question-box">
      <div class="question-title animate-target" v-animate-in>{{ questionTitle }}</div>
      <div class="question-desc animate-target" v-animate-in v-html="questionDesc"></div>
    </div>
    <div class="content-txt">
      <div class="image-view">
        <img class="animate-target" v-animate-in src="../../assets/images/p-1-5/Julia1.png" />
        <img class="animate-target" v-animate-in src="../../assets/images/p-1-5/Julia2.png" />
        <img class="animate-target" v-animate-in src="../../assets/images/p-1-5/Julia3.png" />
        <img class="animate-target" v-animate-in src="../../assets/images/p-1-5/Julia4.png" />
      </div>
    </div>
    <QuestionBox2 class="animate-target" v-animate-in :showItem2="showItem2" :title1="questionTitle1" :title2="questionTitle2" :items1="questionItem1" :items2="questionItem2" :index1="questionAnswer1" :index2="questionAnswer2" v-on:selected="selected"></QuestionBox2>
    <GoNext class="animate-target" v-animate-in href="/section1/1-6" :selected="selectedValue" v-on:secondQuestion="secondQuestion" required="true">Submit</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import QuestionBox from "../../components/QuestionBox";
import QuestionBox2 from "../../components/QuestionBox2";
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
export default {
  name: "s1-5",
  components: {SectionTitle, QuestionBox2, GoNext, ContentNotice},
  data(){
    return {
      questionTitle: "Question 5",
      questionDesc: "Julia has T2D and newly diagnosed CKD with persistent albuminuria.<br>Latest lab results are outlined below.",

      questionTitle1: "Is she a suitable candidate for finerenone treatment?",
      questionItem1:[
        "YES",
        "NO"
      ],
      questionAnswer1:'0',

      questionTitle2: "You are adding finerenone to her treatment regimen. What starting dose should you prescribe?",
      questionItem2:[
        "5 mg",
        "10 mg",
        "15 mg",
        "20 mg"
      ],
      questionAnswer2:'1',
      showItem2: false,

      selectedValue:'',
      noticeTxt:"*Fictitious patient case<br/><div class='brs'></div>CKD, chronic kidney disease; eGFR, estimated glomerular filtration rate; HbA1c, glycated haemoglobin; RASi, Renin-angiotensin system inhibitor; SGLT-2i, sodium-glucose co-transporter 2 inhibitor; T2D, type 2 diabetes, UACR, urine albumin-to-creatinine ratio.",
      title:'Pre-activity quiz'
    }
  },
  methods:{
    selected:function(value){
      this.selectedValue = value;
    },
    secondQuestion:function(value) {
      this.showItem2 = true;
    }
  }
}
</script>

<style scoped>
  @import "../../assets/css/section1/s1.css";
</style>
